import React from 'react';

const Logo = ({ className = "h-12 w-auto", darkBackground = false }) => {
  return (
    <img 
      src={darkBackground ? "/logo_light.png" : "/logo.png"} 
      alt="Teqvis Technologies" 
      className={`${className} object-contain`}
    />
  );
};

export default Logo;
